import { getTemplateStopTypeString } from 'services/enums/TemplateStopType';
import {
  displayAddress,
  displayDeliveryWindow,
} from 'services/util/helperFuncs';

const Columns = {
  stopType: {
    name: 'stopType',
    header: ({ t }) => t('stopType'),
    body: ({ templateStop, t }) =>
      t(getTemplateStopTypeString(templateStop?.stopType)),
  },
  name: {
    name: 'name',
    header: ({ t }) => t('name'),
    body: ({ templateStop }) => templateStop?.name,
  },  
  stopCategory: {
    name: 'stopCategory',
    header: ({ t }) => t('stopCategory'),
    body: ({ templateStop }) => templateStop?.stopCategory,
  },
  address: {
    name: 'address',
    header: ({ t }) => t('address'),
    body: ({ templateStop }) => displayAddress(templateStop?.address),
  },
  deliveryWindow: {
    name: 'deliveryWindow',
    header: ({ t }) => t('deliveryWindow'),
    body: ({ templateStop }) =>
      displayDeliveryWindow(templateStop?.deliveryWindow),
  },
  expandIcon: {
    name: 'expandIcon',
    header: () => '',
    body: () => '',
  },
};

export default Columns;
